<!--
  SubmitButton:AMOE 表单主 CTA(胶囊按钮)
  - props: label / disabled / loading / pageType
  - emit: click
  - disabled 切灰 #BBBDC0(UI-SPEC revision 2 锁死,非 opacity)
  - loading 态隐藏文本,仅 16px 白色旋转 spinner(Stage 1 submitLoading)
  - 不感知 api / 不感知 state 机,纯 UI
-->
<template>
  <button
    class="submit-btn"
    :class="[{ isPC: pageType === 'PC' }, { 'is-disabled': isDisabled, 'is-loading': loading }]"
    :disabled="isDisabled"
    type="button"
    @click="onClick"
  >
    <span
      v-if="loading"
      class="spinner"
      aria-hidden="true"
    />
    <span
      v-else
      class="btn-text"
    >{{ label }}</span>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue-demi';

export default defineComponent({
  name: 'SubmitButton',
  props: {
    label: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    pageType: { type: String as () => 'H5' | 'PC', required: true },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const isDisabled = computed<boolean>(() => props.disabled || props.loading);
    function onClick(): void {
      if (isDisabled.value) return;
      emit('click');
    }
    return { isDisabled, onClick };
  },
});
</script>

<style scoped>
/* H5 (设计稿 750w, 100px = 1rem):Figma 实测 588px 宽胶囊按钮 (默认 mobile-first) */
.submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  background: #F36F12;
  color: #FFFFFF;
  font-weight: 600;
  font-family: MiSans, Arial, sans-serif;
  width: 5.88rem;
  height: 0.92rem;
  padding: 0 0.6rem;
  border-radius: 0.46rem;
  font-size: 0.3077rem;
  line-height: 1.375;
}

.submit-btn.is-disabled {
  background: #BBBDC0;
  color: #FFFFFF;
  cursor: not-allowed;
}

/* PC: 大写 PX 用于跳过 postcss-pxtorem，避免按钮固定尺寸被转成 rem 后受根字号影响 */
.submit-btn.isPC {
  width: 320PX;
  height: 64PX;
  padding: 10PX 80PX;
  border-radius: 10PX;
  font-size: 21.333333PX;
  line-height: 1.5;
}

.submit-btn.isPC .spinner {
  width: 16PX;
  height: 16PX;
  border-width: 2PX;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #FFFFFF;
  border-radius: 50%;
  animation: submit-spin 0.8s linear infinite;
}

@keyframes submit-spin {
  to { transform: rotate(360deg); }
}
</style>
